module.exports = __webpack_public_path__ + "static/media/2-octopus.6be0b083.svg";